import { api } from 'src/services/api';

export class VariantsService {
  static async getProductVariant({ productId, variantId }) {
    return api.get(`/product/product/${productId}/variant/${variantId}`);
  }

  static async getProductInfo({ productId }) {
    return api.get(`/product/product/${productId}`);
  }
}
